import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distance-boxes',
  templateUrl: './distance-boxes.component.html',
  styleUrls: ['./distance-boxes.component.scss']
})
export class DistanceBoxesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
